import {
  Schema,
  email,
  inviteHash,
  inviteHashes,
  shareableId,
  rights,
  tripId,
  userId,
} from './common_schema.js';

const id = Schema.Int;
const status = Schema.Enum('', 'pending', 'rejected');
const inviteId = Schema.Default(Schema.Int, null);

const fields = {
  shareableId,
  userId: Schema.Default(userId, null),
  inviterUserId: userId,
  inviteeUserId: Schema.Default(userId, null),
  inviteeEmail: Schema.Default(email, ''),
  rights,
  status,
  inviteId,
  inviteHash,

  id,
  tripId,
};

const schema = {
  'accept-trip-share': new Schema({
    inviteHash,
  }),
  'get-trip-share-info': new Schema({
    inviteHash,
  }),
  'reject': new Schema({
    inviteHash,
  }),
  'revoke': new Schema({
    inviteHashes,
  }),
  'update': new Schema({
    inviteHash,
    rights,
  }),
};

export { schema as ShareSchema, fields as ShareSchemaFields };
